export const MESSAGE_TYPE = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
};
